import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./multiPickFromList.scss";

function MultiPickFromList(props) {
  const [checkedItems, setCheckedItems] = useState({});
  const {
    itemWasChecked,
    maxChecked,
    defaultCheckedItems = {},
    checkList = [],
    selectHeight,
    hasPreLabel,
    modalWidth
  } = props;

  useEffect(() => {
    // Initialize all to false
    const checkedItems = (checkList || []).reduce((dict, { value }) => {
      dict[value] = false;
      return dict;
    }, {});
    // Overwrite the false with passed in defaults
    setCheckedItems({
      ...checkedItems,
      ...defaultCheckedItems
    });
  }, []);

  const onChange = (e, value) => {
    const newState = {
      ...checkedItems,
      [value]: e.target.checked
    };
    setCheckedItems(newState);
    itemWasChecked(newState);
  };

  return (
    <div style={{ height: selectHeight }} className="MultiPickFromList-selectList">
      {checkList.map(({ preLabel, label, value }) => {
        return (
          <div
            className={`checkListItem ${hasPreLabel ? "withPre" : ""}`}
            key={label + "-" + value}
          >
            <input
              onChange={(e) => onChange(e, value)}
              type="checkbox"
              role="checkbox"
              id={label + "-" + value}
              checked={!!checkedItems[value]}
              disabled={maxChecked && !checkedItems[value]}
            />

            <label
              className="checkListItem__label"
              style={{ backgroundColor: checkedItems[value] && "var(--color-accent)" }}
              htmlFor={label + "-" + value}
            >
              <span
                className={`checkListItem__label__text ${hasPreLabel ? "withPre" : ""}`}
                style={{
                  color: !checkedItems[value] ? "#d1d2d3" : "white",
                  width: modalWidth && modalWidth - 85,
                  opacity: maxChecked && !checkedItems[value] ? 0.5 : 1
                }}
              >
                {hasPreLabel ? (
                  <>
                    <span className="preLabelText">
                      {preLabel}
                      <br />
                    </span>

                    <span className="label-with-preLabel">{label}</span>
                  </>
                ) : (
                  label
                )}
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
}

MultiPickFromList.propTypes = {
  checkList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any
    })
  ),
  modalWidth: PropTypes.number,
  checkedItems: PropTypes.object,
  defaultCheckedItems: PropTypes.object,
  selectHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemWasChecked: PropTypes.func,
  maxChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  hasPreLabel: PropTypes.bool
};

export default MultiPickFromList;
